import type { SmartFormConfig } from '@pesto/ui/features/SmartForm/types';

import { SmartForm } from '@pesto/ui/features/SmartForm/SmartForm';

interface CreateFormComponentProps {
  config: SmartFormConfig<any>;
  handleSubmit: (data: any) => void | Promise<void>;
  loading?: boolean;
  mode?: 'create' | 'edit';
}

export const createFormComponent = ({ config, handleSubmit, loading, mode }: CreateFormComponentProps) => {
  return (
    <div className="flex flex-col gap-4">
      <SmartForm config={config} onSubmit={handleSubmit} loading={loading} mode={mode} />
    </div>
  );
};
